import React, { useState } from 'react';

const AssignmentForm = ({ onSave, vehicles, drivers, user }) => {
  const [formData, setFormData] = useState({
    vehiclePlate: '',
    driverLicense: '',
    startDate: new Date().toISOString().split('T')[0],
    endDate: '',
    notes: '',
    isMain: false
  });

  const [errorMsg, setErrorMsg] = useState("");

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formData.vehiclePlate || !formData.driverLicense) {
      setErrorMsg("Debes seleccionar vehículo y conductor");
      return;
    }
    try {
      await onSave({
        ...formData,
        createdBy: user?.email || "sistema",
        modifiedBy: user?.email || "sistema"
      });
      setFormData({
        vehiclePlate: '',
        driverLicense: '',
        startDate: new Date().toISOString().split('T')[0],
        endDate: '',
        notes: '',
        isMain: false
      });
      setErrorMsg("");
    } catch (err) {
      setErrorMsg("Error al guardar la asignación");
    }
  };

  return (
    <div className="bg-white rounded-xl shadow-md p-6">
      <h3 className="text-lg font-bold mb-4">Asignar Vehículo</h3>
      <form onSubmit={handleSubmit}>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-4">
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Vehículo</label>
            <select
              name="vehiclePlate"
              value={formData.vehiclePlate}
              onChange={handleChange}
              className="w-full px-3 py-2 border border-gray-300 rounded-md"
              required
            >
              <option value="">Seleccionar vehículo</option>
              {vehicles.map(vehicle => (
                <option key={vehicle.plate} value={vehicle.plate}>
                  {vehicle.brand} {vehicle.model} ({vehicle.plate})
                </option>
              ))}
            </select>
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Conductor</label>
            <select
              name="driverLicense"
              value={formData.driverLicense}
              onChange={handleChange}
              className="w-full px-3 py-2 border border-gray-300 rounded-md"
              required
            >
              <option value="">Seleccionar conductor</option>
              {drivers.map(driver => (
                <option key={driver.license} value={driver.license}>
                  {driver.name} ({driver.license})
                </option>
              ))}
            </select>
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Fecha de inicio</label>
            <input
              type="date"
              name="startDate"
              value={formData.startDate}
              onChange={handleChange}
              className="w-full px-3 py-2 border border-gray-300 rounded-md"
              required
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Fecha de fin (opcional)</label>
            <input
              type="date"
              name="endDate"
              value={formData.endDate}
              onChange={handleChange}
              min={formData.startDate}
              className="w-full px-3 py-2 border border-gray-300 rounded-md"
            />
          </div>
          <div className="md:col-span-2">
            <label className="block text-sm font-medium text-gray-700 mb-1">Notas</label>
            <textarea
              name="notes"
              value={formData.notes}
              onChange={handleChange}
              rows="3"
              className="w-full px-3 py-2 border border-gray-300 rounded-md"
            />
          </div>
          <div className="md:col-span-2 flex items-center">
            <input
              type="checkbox"
              name="isMain"
              checked={formData.isMain}
              onChange={handleChange}
              className="mr-2"
            />
            <label className="text-sm font-medium text-gray-700">Asignación principal</label>
          </div>
        </div>
        {errorMsg && (
          <div className="mb-2 text-red-600">{errorMsg}</div>
        )}
        <button
          type="submit"
          className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700"
        >
          Guardar Asignación
        </button>
      </form>
    </div>
  );
};

export default AssignmentForm;